import styled from "styled-components"

import {EXTRA_LARGE_DESKTOP, minWidthMedia} from "@irati/ui/src/global/media"
import waitImage from "@irati/ui/images/wait.svg"

export const FullWidth = styled.div`
  width: 100%;
`

export const FlexContainer = styled.div`
  display: flex;
  overflow-y: auto;
`

export const PartialGrid = styled.div`
  margin: 0 auto;
  ${minWidthMedia.extraLargeDesktop`
    width: ${EXTRA_LARGE_DESKTOP}px;
  `}
`

interface Props {
  sizeInPx?: number
}
const DEFAULT_SIZE = 150
export const WaitImage = styled.div<Props>`
  height: ${({sizeInPx}) => sizeInPx || DEFAULT_SIZE}px;
  width: ${({sizeInPx}) => sizeInPx || DEFAULT_SIZE}px;
  background-image: url(${waitImage});
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
  margin-bottom: 30px;
`
